export const isResultSaveable = id => {
	return [
		"8468", // Danger Assessment (Male Partner)
		"8484", // Danger Assessment (Female Partner)
		"8521", // Safety Actions
		"8503", // Assess Your Health
		"8441", // Healthy Partner Relationships
	].includes(id);
};
